<template>
  <section class="container">
    <div class="stepActive" v-if="refundorderdetail.type1==2">
      <el-steps :active="stepActive" finish-status="success" align-center>
        <el-step title="买家申请退货退款"></el-step>
        <el-step title="卖家处理退货申请"></el-step>
        <el-step title="买家退货"></el-step>
        <el-step title="退款完毕"></el-step>
      </el-steps>
    </div>
    <div class="stepActive" v-else>
      <el-steps :active="stepActive" finish-status="success" align-center>
        <el-step title="买家申请退货退款"></el-step>
        <el-step title="卖家处理退货申请"></el-step>
        <el-step title="退款完毕"></el-step>
      </el-steps>
    </div>
    <div class="applyReturn flex">
      <el-form
        v-if="stepActive==1"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm box"
      >
        <el-form-item label="退货商品">
          <div class="tablegoodsinfo">
            <div class>
              <div class="clearfix cpinfo flex">
                <div class="img" style="width:100px;height:100px">
                  <a :href="'#/goodsdetail?id='+ orderDetail.detail.id" target="_blank">
                    <img :src="orderDetail.detail.indexpic" />
                  </a>
                </div>
                <div class="cont flex" style="margin-left:10px;width:650px;">
                  <div class>
                    <div class="name bold ellipsis-2">{{orderDetail.detail.title}}</div>
                    <div class="info">{{orderDetail.detail.specnames}}</div>
                    <div class="cart-price">{{orderDetail.detail.price}}*{{orderDetail.detail.num}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="退款原因" prop="type">
          <el-select v-model="ruleForm.type" style="width:50%" placeholder="请选择退款原因">
            <el-option
              :label="item"
              :value="index"
              v-for="(item,index) in refundconfig.refundreason"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退款数量" prop="numbers">
          <el-input
            type="number"
            placeholder="请输入退款数量"
            @input="changeNum"
            style="width:50%"
            v-model="ruleForm.numbers"
          ></el-input>
          <div class="color-red">最多可退{{orderDetail.detail.num}}{{orderDetail.detail.unit}}</div>
        </el-form-item>
        <el-form-item label="退款金额" prop="amount">
          <el-input
            type="number"
            @input="changeMoney"
            placeholder="请输入退款金额"
            style="width:50%"
            v-model="ruleForm.amount"
          ></el-input>
          <div class="color-red">最高可退￥{{(ruleForm.numbers*orderDetail.detail.price).toFixed(2)}}</div>
        </el-form-item>
        <el-form-item label="服务类型" prop="type1">
          <el-radio-group v-model="ruleForm.type1">
            <el-radio label="1" v-if="ruleForm.type1=='1'">仅退款</el-radio>
            <el-radio label="2" v-if="ruleForm.type1=='2'">退货退款</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="退款说明">
          <el-input
            type="textarea"
            placeholder="请输入退款说明"
            style="width:50%;"
            :autosize="{ minRows: 4, maxRows: 6}"
            v-model="ruleForm.remark"
          ></el-input>
        </el-form-item>

        <el-form-item label="上传图片">
          <div class="title" style="width:500px;height:180px">
            <div class="cont">
              <el-upload
                multiple
                :limit="limit"
                :action="uploadimg"
                list-type="picture-card"
                :file-list="fileList"
                :on-preview="handlePictureCardPreview"
                :on-change="filechange"
                :on-remove="handleRemove"
                :on-exceed="exceed"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible" size="tiny">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">立即提交</el-button>
        </el-form-item>
      </el-form>
      <div class="returnIng demo-ruleForm box" v-if="stepActive==2">
        <div class="bold tit">请等待商家处理</div>
        <div class="desc border-b status">你已成功发起退货申请，请耐心等待商家处理。</div>
        <ul class="desc relust">
          <li>商家同意，系统将退款给您 (钱原路返回)</li>
          <li>如果商家拒绝，您可以修改退款申请后再次发起，商家会重新处理</li>
        </ul>
        <button type="primary" class="resultApply center bold" @click="modifyApply">修改申请</button>
        <div class="desc flex border-b chexiao">
          <span>您还可以：</span>
          <a href="javascript:;" class="color-primary" @click="chexiao">撤销申请</a>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <a
            href="#/usercenter?type=1-4"
            class="color-primary"
          >返回订单列表</a>
        </div>
      </div>
      <el-form
        v-if="stepActive==3&&refundorderdetail.type1==2"
        :model="ruleFormAddress"
        :rules="rulesAddress"
        ref="ruleFormAddress"
        label-width="100px"
        class="demo-ruleForm box"
      >
        <el-form-item label class="storeInfo">
          <div v-if="refundorderdetail.status1==4">
            <div class="bold fs16">
              商家拒绝收货
              <span class="color-red">(拒绝原因:{{refundorderdetail.remark1}})</span>
            </div>
            <div>
              快递公司：{{refundconfig.expresslist[ruleFormAddress.expressid]}}
            </div>
            <div>
              快递单号：{{ruleFormAddress.expressno}}
            </div>
          </div>
          <div v-else>
            <div class="bold fs16">商家已同意退货申请，请尽早发货。</div>
            <div class="bold fs16">退货地址：</div>
            <div
              class="bold fs16"
            >联系人 : {{refundorderdetail.shopuser }} {{refundorderdetail.shoptelephone }}</div>
            <div class="bold fs16">地址 : {{refundorderdetail.address }}</div>
          </div>
        </el-form-item>
        <el-form-item label="快递公司" prop="expressid" v-if="refundorderdetail.status1!=4">
          <el-select v-model="ruleFormAddress.expressid" style="width:50%" placeholder="请选择快递公司">
            <el-option
              :label="item"
              :value="index"
              v-for="(item,index) in refundconfig.expresslist"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运单号" prop="expressno"  v-if="refundorderdetail.status1!=4">
          <el-input
            type="text"
            placeholder="请输入运单号"
            :max="orderDetail.detail.num"
            style="width:50%"
            v-model="ruleFormAddress.expressno"
          ></el-input>
        </el-form-item>

        <el-form-item  v-if="refundorderdetail.status1!=4">
          <div class="flex">
            <el-button type="primary" @click="submitFormaddress('ruleFormAddress')">立即提交</el-button>
            <div
              class="color-red fs16"
              style="margin-left:12px;"
              v-if="refundorderdetail.expressno"
            >提交成功，等待商家退款</div>
          </div>
        </el-form-item>
        <el-form-item  v-if="refundorderdetail.status1==4">
          <button type="primary" class="resultApply center bold" @click="modifyApply">重新申请</button>
          <div class="desc flex border-b chexiao">
            <span>您还可以：</span>
            <a href="javascript:;" class="color-primary" @click="chexiao">撤销申请</a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a
              href="#/usercenter?type=1-4"
              class="color-primary"
            >返回订单列表</a>
          </div>
        </el-form-item>
      </el-form>
      <div
        class="returnIng demo-ruleForm box"
        v-if="(stepActive==4)||(stepActive==3&&refundorderdetail.type1==1)"
      >
        <div v-if="refundorderdetail.status==3">
          <div class="bold tit">退款成功</div>
          <div class="desc border-b status">退款成功时间：{{refundorderdetail.dealtime}}</div>
          <div class="desc border-b status">
            退款金额：
            <span class="color-primary">￥{{refundorderdetail.amount1}}</span>
          </div>
        </div>
        <div v-else-if="refundorderdetail.status==1">
          <div class="bold tit">
            <span v-if="refundorderdetail.type1==2">商家已收货。</span> 退款处理中
          </div>
          <div class="desc border-b status">
            退款金额：
            <span class="color-primary">￥{{refundorderdetail.amount}}</span>
          </div>
        </div>
        <div v-else-if="refundorderdetail.status==2">
          <div class="bold tit">
            <span v-if="refundorderdetail.type1==2">商家已收货。</span> 退款失败
          </div>
          <div class="desc border-b status">退款失败原因：{{refundorderdetail.remark1}}</div>
          <div class="desc border-b status">退款失败时间：{{refundorderdetail.dealtime}}</div>
          <button type="primary" class="resultApply center bold" @click="modifyApply">修改申请</button>
          <div class="desc flex border-b chexiao">
            <span>您还可以：</span>
            <a href="javascript:;" class="color-primary" @click="chexiao">撤销申请</a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a
              href="#/usercenter?type=1-1"
              class="color-primary"
            >返回订单列表</a>
          </div>
        </div>
      </div>
      <div class="orderinfo box">
        <div class="bold center tit">订单信息</div>
        <div class="tablegoodsinfo">
          <div class>
            <div class="clearfix cpinfo flex">
              <div class="img" style="width:100px;height:100px">
                <a :href="'#/goodsdetail?id='+ orderDetail.detail.productid" target="_blank">
                  <img :src="orderDetail.detail.indexpic" />
                </a>
              </div>
              <div class="cont flex" style="margin-left:10px;">
                <div class>
                  <div class="name bold ellipsis-2">{{orderDetail.detail.title}}</div>
                  <div class="info">{{orderDetail.detail.specnames}}</div>
                  <div class="cart-price">{{orderDetail.detail.price}}*{{orderDetail.detail.num}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex goods_info">
          <span class="desc">订单编号:</span>
          <span class="color-primary">{{orderDetail.orderno}}</span>
        </div>
        <div class="flex goods_info">
          <span class="desc">单价:</span>
          <span class="color-primary">{{orderDetail.detail.price}}*{{orderDetail.detail.num}}</span>
        </div>
        <div class="flex goods_info">
          <span class="desc">运费:</span>
          <span class="color-primary">{{orderDetail.detail.shipfee}}</span>
        </div>
        <div class="flex goods_info">
          <span class="desc">商品总额:</span>
          <span
            class="color-primary"
          >{{(orderDetail.detail.price*orderDetail.detail.num).toFixed(2)}}</span>
        </div>
        <div v-if="stepActive>1">
          <div class="bold center tit">退款信息</div>
          <div class="flex goods_info">
            <span class="desc">退款编号:</span>
            <span class="color-primary">{{refundorderdetail.orderno}}</span>
          </div>
          <div class="flex goods_info">
            <span class="desc">退款金额:</span>
            <span class="color-primary">{{refundorderdetail.amount}}</span>
          </div>
          <div class="flex goods_info">
            <span class="desc">原因:</span>
            <span class="color-primary">{{refundconfig.refundreason[refundorderdetail.type]}}</span>
          </div>
          <div class="flex goods_info">
            <span class="desc">要求:</span>
            <span class="color-primary" v-if="refundorderdetail.type==1">仅退款</span>
            <span class="color-primary" v-else>退款退货</span>
          </div>
          <div class="flex goods_info">
            <span class="desc">货物状态:</span>
            <span class="color-primary">{{refundstatus1[refundorderdetail.status1]}}</span>
          </div>
          <div class="flex goods_info">
            <span class="desc">说明:</span>
            <span class="color-primary">{{refundorderdetail.remark}}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "applayReturn",
  inject: ["reload"], //注入reload方法
  data() {
    var valiNumberMoney = (rule, value, callback) => {
      //包含小数的数字
      let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
      if (value === "") {
        callback(new Error("请输入金额"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的金额"));
      } else {
        callback();
      }
    };
    return {
      limit: 6,
      orderno: getParameterByName("orderno"),
      numrefund: getParameterByName("numrefund") || 0,
      index: getParameterByName("index"),
      type: getParameterByName("type"),
      refundorder: getParameterByName("refundorder"),
      detailid: getParameterByName("detailid") || "",
      uploadimg: sessionStorage.baseUrl + "app/file/upload",
      dialogImageUrl: "",
      fileList: [],
      orderDetail: { detail: { productid: "" } },
      dialogVisible: false,
      stepActive: 3,
      refundstatus: {
        "1": "待处理",
        "2": "拒绝退款",
        "3": "已退款"
      },
      refundstatus1: {
        "0": "退货审核中",
        "1": "待回寄",
        "2": "待收货",
        "3": "已退货"
      },
      ruleFormAddress: {
        expressno: "",
        expressid: "",
        address: ""
      },
      refundconfig: { refundreason: {}, expresslist: {} },
      refundorderdetail: {},
      ruleForm: {
        type1: "1",
        numbers: "1",
        type: "",
        amount: "",
        desc: "",
        remark: ""
      },
      rulesAddress: {
        expressno: [
          { required: true, message: "请输入运单号", trigger: "change" }
        ],
        expressid: [
          { required: true, message: "请选择快递公司", trigger: "change" }
        ]
      },
      rules: {
        type1: [
          { required: true, message: "请选择服务类型", trigger: "change" }
        ],
        amount: [
          { required: true, validator: valiNumberMoney, trigger: "change" }
        ],
        numbers: [
          { required: true, message: "请输入退款数量", trigger: "change" }
        ],
        type: [{ required: true, message: "请选择退款原因", trigger: "change" }]
      }
    };
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.ruleForm.numbers <= 0) {
            this.$message.error("退款数量需要大于0");
            return;
          }
          if (this.ruleForm.numbers > this.orderDetail.detail.num) {
            this.$message.error(
              `最多可退${this.orderDetail.detail.num}${this.orderDetail.detail
                .unit || ""}`
            );
            return;
          }
          if (this.ruleForm.amount <= 0) {
            this.$message.error("退款金额需要大于0");
            return;
          }
          let total = this.ruleForm.numbers * this.orderDetail.detail.price;
          if (this.ruleForm.amount > total) {
            this.$message.error(`最高可退￥${total}`);
            return;
          }
          let photo = this.fileList.map(item => item.response.msg);
          let $data = Object.assign(this.ruleForm, {
            photo,
            num: this.ruleForm.numbers,
            orderno: this.orderno,
            detailid: this.orderDetail.detail.id
          });
          delete $data.numbers;
          let url = "member/refundorder";
          if (this.refundorder) {
            url = "member/processrefund";
            $data["act"] = 4;
            $data.orderno = this.refundorder;
            delete $data.detailid;
          }
          let refundorder = await this.$fetch(url, { body: $data });
          if (!refundorder) {
            this.$message.error("申请失败请联系客服");
            return;
          }
          this.refundorder = refundorder;
          this.$router.replace(
            "/returnMoney?type=2&refundorder=" + refundorder
          );
          this.reload(); //直接调用
        } else {
          return false;
        }
      });
    },
    // 提交快递
    submitFormaddress(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let $data = Object.assign(this.ruleFormAddress, {
            orderno: this.refundorder,
            act: "2"
          });
          let res = await this.$fetch("member/processrefund", { body: $data });
          // console.log(res);
          if (res) {
            this.getRefundorderdetail();
            // this.$message.success("提交成功");
            this.$alert("提交成功，等待商家退款", "温馨提示");
          } else {
            this.$message.error("申请失败请联系客服");
            return;
          }
        } else {
          return false;
        }
      });
    },
    // 修改申请
    async modifyApply() {
      if (!this.refundorder) {
        this.$message.error("网络错误,请稍后再试");
        return;
      }
      await this.getRefundorderdetail();
      let res = this.refundorderdetail;
      this.refundorder = res.orderno;

      for (let key in this.ruleForm) {
        this.ruleForm[key] = res[key];
      }
      this.ruleForm.numbers = res.num;
      this.fileList = res.photo || [];
      this.fileList = this.fileList.map(item => {
        if (item.indexOf("http") == -1) {
          item = sessionStorage.baseUrl + item;
        }
        return { name: "update", url: item, response: { code: 0, msg: item } };
      });
      this.stepActive = 1;
    },
    // 获取退换货详情
    async getRefundorderdetail() {
      let res = await this.$fetch("member/refundorderdetail", {
        body: {
          orderno: this.refundorder,
          detailid: this.detailid
        }
      });
      res.type += "";
      res.type1 += "";
      // 仅退款的时候
      if (res.type1 == 1) {
        if (res.status == 1) {
          this.stepActive = 2;
        } else if (res.status == 3 || res.status == 2) {
          this.stepActive = 3;
        }
      } else if (res.type1 == 2) {
        if (res.status1 == 0) {
          this.stepActive = 2;
        } else if (res.status1 == 1 || res.status1 == 2 || res.status1 == 4) {
          this.stepActive = 3;
        } else if (res.status1 == 3) {
          this.stepActive = 4;
        }
        this.ruleFormAddress.expressid = res.expressid + "";
        this.ruleFormAddress.expressno = res.expressno;
      }
      if (this.numrefund > 0) {
        res.num = this.numrefund;
      }
      this.orderDetail.detail = res;
      this.refundorderdetail = res;
      this.refundorder = res.orderno;
    },
    // 封装获取数据的方法
    async getOrderDetail() {
      let res = await this.$fetch("Member/orderdetail", {
        body: { orderno: this.orderno }
      });
      if (res.status < 5 && this.type == 1) {
        this.stepActive = 1;
      }
      if (res.status == 1) {
        this.ruleForm.type1 = "1";
      } else {
        this.ruleForm.type1 = "2";
      }
      res.detail = res.detail[this.index];
      if (this.numrefund > 0) {
        res.detail.num = this.numrefund;
      }
      res.shipfee = parseFloat(res.shipfee);
      res.amount = parseFloat(res.amount);
      this.orderDetail = res;
    },
    chexiao() {
      if (!this.refundorder) {
        this.$message.error("网络错误,请稍后再试");
        return;
      }
      this.$confirm("此操作将撤销申请, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await this.$fetch("member/processrefund", {
            body: {
              orderno: this.refundorder,
              act: "5"
            }
          });
          if (res) {
            this.$message.success("撤销成功");
            this.$router.push("/usercenter?type=1-1");
          }
        })
        .catch(() => {});
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    changeNum(e) {
      console.log(e, this.orderDetail.detail.num);
      if (Number(e) > Number(this.orderDetail.detail.num)) {
        this.$message.error(
          `最多可退${this.orderDetail.detail.num}${this.orderDetail.detail
            .unit || ""}`
        );
        this.ruleForm.numbers = this.orderDetail.detail.num;
      }
      if (e <= 0 && e != "") {
        this.$message.error(`退款数量至少一件`);
        this.ruleForm.numbers = 1;
      }
    },
    changeMoney(e) {
      let total = Number(this.ruleForm.numbers * this.orderDetail.detail.price);
      if (e > total) {
        this.$message.error(`最高可退￥${total.toFixed(2)}`);
        this.ruleForm.amount = total;
        return;
      }
      if (e < 0 && e != "") {
        this.$message.error("退款金额需要大于等于0");
        this.ruleForm.amount = 0;
        return;
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    filechange(file, fileList) {
      this.fileList = fileList;
      console.log(this.fileList);
    },
    exceed(files, fileList) {
      this.$message.error(`最多只能上传${this.limit}张图片！`);
    }
  },
  async mounted() {
    this.refundconfig = await this.$fetch("member/refundconfig");
    if (this.refundorder || this.detailid) {
      await this.getRefundorderdetail();
    }
    if (this.orderno) {
      this.getOrderDetail();
    }
  }
};
</script>

<style lang='scss' scoped>
.user-cont {
  align-items: flex-start;
}
.container {
  background: #fff;
  padding-top: 20px;
}
.row {
  margin: 20px 0;
}

.cont {
  padding: 10px 0;
  .el-rate__item {
    i {
      font-size: 30px;
    }
  }
}
.num_text {
  display: flex;
  width: 300px;
  flex-direction: column;
  justify-content: space-around;
  .row {
    margin: 0;
  }
}
.img {
  width: 200px;
  height: 200px;
  // a {
  //   display: inline-block;
  //   width: 100%;
  //   height: 100%;
  img {
    width: 100%;
    height: 100%;
  }
  // }
}
// body{
//   background: #fff !important;
// }
</style>



// WEBPACK FOOTER //
// src/pages/returnMoney.vue